import { AxiosError, AxiosResponse } from "axios";
import http from "../common/http-commons";

import { IGetListRequest, IResponse, IServerError } from "../models/common";

import { IEarningSummary } from "../models/EarningSummary";

export const EarningSummaryService = {
	getEmployeePayrollEarningSummary: async (
		clientId: string,
		employeeId: string | null,
		payPeriodFrequencyId: string | null,
		payPeriodEndDate: string | null,
		navigateToLogout: (path: string) => void,
	): Promise<IEarningSummary | IServerError | IResponse | any> => {
		if (employeeId) {
			try {
				const response: AxiosResponse<IEarningSummary> =
					await http.get<IEarningSummary>(
						`/v1/employee-payroll-data/payroll-data/by-client-id/payroll_shedule_id/employee-id/${clientId}/?employee_id=${employeeId}&pay_period_frequency_id=${payPeriodFrequencyId}&pay_period_end_date=${payPeriodEndDate}`,
					);
				if (response.status === 200) {
					return response.data;
				} else if (response.status === 201) {
					return response.data;
				} else if (response.status === 400) {
					return {
						status: false,
						message: "Bad Request.",
						error: true,
					};
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
				return {
					status: false,
					message: "Something went wrong please try again later.",
				};
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}
		return null;
	},

	create: async (
		requestPayload: any,
	): Promise<IEarningSummary | IServerError | IResponse | any> => {
		if (requestPayload.id) {
			try {
				const response: AxiosResponse<IEarningSummary> =
					await http.put<IEarningSummary>(
						`/v1/employee-payroll-data/${requestPayload.id}/`,
						requestPayload,
					);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		try {
			const response: AxiosResponse<IEarningSummary> =
				await http.post<IEarningSummary>(
					`/v1/employee-payroll-data/`,
					requestPayload,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	createPayroll: async (
		requestPayload: any,
	): Promise<IEarningSummary | IServerError | IResponse | any> => {
		if (requestPayload.id) {
			try {
				const response: AxiosResponse<IEarningSummary> =
					await http.put<IEarningSummary>(
						`/v1/payroll-engine/only-calculate-single-employee/${requestPayload.id}/`,
						requestPayload,
					);

				if (response.status === 200) {
					return response;
				} else if (response.status === 400) {
					return response.data;
				} else if (response.status === 500) {
					return {
						status: false,
						message: "Something went wrong.",
						error: true,
					};
				}
			} catch (error) {
				const axiosError = error as AxiosError;
				console.error("An error occurred:", axiosError);
				const errorMessage =
					axiosError.response && typeof axiosError.response.data === "string"
						? axiosError.response.data
						: "Unknown error";
				if (axiosError && axiosError.status === 401) {
					requestPayload.navigateToLogout("/logout");
					return {
						status: false,
						message: "UnAuthrized",
					};
				} else {
					return {
						status: false,
						message: errorMessage,
					};
				}
			}
		}

		try {
			const response: AxiosResponse<IEarningSummary> =
				await http.post<IEarningSummary>(
					`/v1/payroll-engine/only-calculate-single-employee/`,
					requestPayload,
				);

			if (response.status === 201) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 401) {
				// window.location.href = '/logout';
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},
};
